import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import KeyCode from 'choerodon-ui/lib/_util/KeyCode';
import { CheckBox } from '../check-box/CheckBox';
import autobind from '../_util/autobind';
let Switch = class Switch extends CheckBox {
    handleKeyDown(e) {
        if (e.keyCode === KeyCode.LEFT) {
            this.setChecked(false);
        }
        else if (e.keyCode === KeyCode.RIGHT) {
            this.setChecked(true);
        }
        super.handleKeyDown(e);
    }
    getLabelText() {
        return undefined;
    }
    getTextNode() {
        const { prefixCls, props: { children, unCheckedChildren }, } = this;
        const text = this.isChecked() ? children : unCheckedChildren || children;
        return React.createElement("span", { className: `${prefixCls}-label` }, text);
    }
    renderSwitchFloatLabel() {
        const { prefixCls, } = this;
        return (React.createElement("span", { className: `${prefixCls}-float-label` }, this.getLabelChildren()));
    }
    renderInner() {
        return undefined;
    }
};
Switch.displayName = 'Switch';
/**
 * tooltip disable sign
 */
// eslint-disable-next-line camelcase
Switch.__PRO_SWITCH = true;
// eslint-disable-next-line camelcase
Switch.__IS_IN_CELL_EDITOR = true;
Switch.defaultProps = {
    ...CheckBox.defaultProps,
    suffixCls: 'switch',
};
__decorate([
    autobind
], Switch.prototype, "handleKeyDown", null);
Switch = __decorate([
    observer
], Switch);
export default Switch;
